module.exports = __webpack_public_path__ + "static/media/home_bg.694559ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/home_bg.svg
// module id = 78
// module chunks = 0